import apiClient from './apiClient';

const BASE = '/recepcion/volver-a-contactar';

/**
 * Listado "Volver a contactar" (V261): las atenciones que no avanzaron (No viable / No quiso dejar
 * carpeta) y que el estudio quiere volver a buscar. Molde: jaureguiService (filtros como params
 * sueltos, igual que los otros listados).
 */
export const listarVolverAContactar = async (filtros = {}, page = 0, size = 50, texto = '') => {
    const params = { page, size };
    if (texto && texto.trim() !== '') params.texto = texto.trim();
    if (filtros.motivo) params.motivo = filtros.motivo;
    if (filtros.tipoTramite) params.tipoTramite = filtros.tipoTramite;
    const { data } = await apiClient.get(BASE, { params });
    return data;
};

/** Los idTurno del rango que ya están en el listado (marca de las filas del histórico). */
export const turnosEnListado = async (desdeISO, hastaISO) => {
    const { data } = await apiClient.get(`${BASE}/turnos`, { params: { desde: desdeISO, hasta: hastaISO } });
    return Array.isArray(data) ? data : [];
};

/** @param alta { idTurno, avisarDesde?: 'YYYY-MM-DD', nota? } */
export const agregarAVolverAContactar = async (alta) => {
    const { data } = await apiClient.post(BASE, alta);
    return data;
};

/** El aviso tal como saldría: { telefono, mensaje }. */
export const vistaPreviaAviso = async (id) => {
    const { data } = await apiClient.get(`${BASE}/${id}/vista-previa-aviso`);
    return data;
};

/** Manda el aviso por WhatsApp. Devuelve { registro, quedoEnCola }. */
export const avisarVolverAContactar = async (id, mensaje) => {
    const { data } = await apiClient.post(`${BASE}/${id}/avisar`, { mensaje });
    return data;
};

export const quitarDeVolverAContactar = async (id, motivo) => {
    await apiClient.delete(`${BASE}/${id}`, { params: motivo ? { motivo } : {} });
};

export const getPlantillaVolverAContactar = async () => {
    const { data } = await apiClient.get('/configuracion/plantilla-volver-a-contactar');
    return data?.plantilla || '';
};

export const guardarPlantillaVolverAContactar = async (plantilla) => {
    const { data } = await apiClient.put('/configuracion/plantilla-volver-a-contactar', { plantilla });
    return data?.plantilla || '';
};

/** El mensaje de error que manda el backend (ApiError.message), o el genérico. */
export const mensajeDeError = (err, generico) => err?.response?.data?.message
    || err?.response?.data?.mensaje
    || generico;
